var n = /* @__PURE__ */ ((e) => (e.Inline = "inline", e.InlineBetween = "inline-between", e.InlineReverse = "inline-reverse", e.Stack = "stack", e))(n || {});
const i = [
  "inline",
  "inline-between",
  "inline-reverse",
  "stack"
];
export {
  i as TOGGLE_LAYOUTS,
  n as ToggleLayout
};
